<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <ul class="tabs">
        <li class="tab" @click="setActiveTab('SHARED')">
          <a :class="['tab-link', {'a-active': activeTab === 'SHARED'}]" href="#">{{ $t('general.shared') }}</a>
        </li>
        <li class="tab" @click="setActiveTab('UNSHARED')">
          <a :class="['tab-link', {'a-active': activeTab === 'UNSHARED'}]" href="#">{{ $t('general.unshared') }}</a>
        </li>
      </ul>

      <!-- Invoices Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'SHARED'" >
          <div class="row">
            <table-component
              ref="table"
              :show-filter="false"
              :data="sharingProfileUsers"
              table-class="table"
            >
            <table-column
              :label="$t('general.company_name')"
              show="company_name"
            />
            <table-column
              :label="$t('funders.display_name')"
              show="name"
            />
            <table-column
              :label="$t('funders.contact_name')"
              show="contact_name"
            />
            <table-column
              :label="$t('funders.phone')"
              show="phone"
            />
            </table-component>
          </div>
        </div>
      </transition>

      <!-- Invoices Tab -->
      <transition name="fade-customize">
        <div v-if="activeTab === 'UNSHARED'">
          <div v-show="!showEmptyScreen" class="table-container">
            <div class="table-actions">
              <p class="table-stats">{{ $t('general.showing') }}: <b>{{ unSharingProfileUsers.length }}</b></p>

              <transition name="fade">
                <v-dropdown v-if="selectedUsers.length" :show-arrow="false">
                  <span slot="activator" href="#" class="table-actions-button dropdown-toggle">
                    {{ $t('general.actions') }}
                  </span>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="sharedProfile">
                      <font-awesome-icon :icon="['fas', 'share']" class="dropdown-item-icon" />
                      {{ $t('general.shared') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
                
              </transition>
            </div>
            <div class="custom-control custom-checkbox">
              <input
                id="select-all"
                v-model="selectAllFieldStatus"
                type="checkbox"
                class="custom-control-input"
                @change="selectAllUsers"
              >
              <label for="select-all" class="custom-control-label selectall">
                <span class="select-all-label">{{ $t('general.select_all') }} </span>
              </label>
            </div>

            <table-component
              ref="table"
              :show-filter="false"
              :data="unSharingProfileUsers"
              table-class="table"
            >
              <table-column
                :sortable="false"
                :filterable="false"
                cell-class="no-click"
              >
                <template slot-scope="row">
                  <div class="custom-control custom-checkbox">
                    <input
                      :id="row.id"
                      v-model="selectField"
                      :value="row.id"
                      type="checkbox"
                      class="custom-control-input"
                    >
                    <label :for="row.id" class="custom-control-label" />
                  </div>
                </template>
              </table-column>
              <table-column
                :label="$t('funders.display_name')"
                show="name"
              />
              <table-column
                :label="$t('funders.contact_name')"
                show="contact_name"
              />
              <table-column
                :label="$t('funders.phone')"
                show="phone"
              />
            </table-component>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import IconUpload from '../../components/icon/upload'
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
const { required, email, maxLength } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      activeTab: 'SHARED',
      formData: {
        sharing_profile_code: null,
      },
      isLoading: false,
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters('profileSharing', [
      'sharingProfileUsers',
      'unSharingProfileUsers',
      'selectedUsers',
      'selectAllField'
    ]),
    showEmptyScreen () {
      return !this.unSharingProfileUsers
    },
    selectField: {
      get: function () {
        return this.selectedUsers
      },
      set: function (val) {
        this.selectUser(val)
      }
    },
    selectAllFieldStatus: {
      get: function () {
        return this.selectAllField
      },
      set: function (val) {
        this.setSelectAllState(val)
      }
    }
  }, 
  created() {
      this.loadData();
  },
  methods: {  
    ...mapActions('profileSharing', [
      'loadProfileSharingData',
      'selectAllUsers',
      'selectUser',
      'setSelectAllState',
      'sharedProfileMultipleUsers'
    ]),
    async loadData(){
      let response = await this.loadProfileSharingData()
    },

    setActiveTab (val) {
      this.activeTab = val
    },
    async sharedProfile () {
      let request = await this.sharedProfileMultipleUsers()
      if (request.data.success) {
        window.toastr['success'](this.$tc('general.profile_shared_message'))
        this.loadData();
      }else if (request.data.error) {
        window.toastr['error'](request.data.message)
      }
    }
    
  }
}
</script>
<style>
  .fade-customize-enter-active {
    transition: opacity 0.9s;
  }

  .fade-customize-leave-active  {
    transition: opacity 0s;
  }

  .fade-customize-enter, .fade-customize-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
